import ContentLayout from '@/layouts/content-layout'
import ProfileView from '@/sections/profile/view/profile-view'

export default function ProfilePage() {
  return (
    <ContentLayout title="โปรไฟล์">
      <ProfileView />
    </ContentLayout>
  )
}
